export default __webpack_public_path__ + "c1764dd9c41d13975ab6d212e1f11ce8.woff";